export const schoolWishlistKeys = {
    all: ['school-wishlist'] as const,
    total: () => [...schoolWishlistKeys.all, 'total'] as const,
    membership: (materialId: number) => [...schoolWishlistKeys.all, 'membership', materialId] as const
} as const;

// Invalidations:
// useSubscribeSchool   → optimistic on schoolWishlistKeys.membership(materialId) + schoolWishlistKeys.total();
//                        on error rolls back + invalidates schoolWishlistKeys.membership(materialId);
//                        on settle invalidates schoolWishlistKeys.total() + wishlistKeys.membership('user', world,
//                        materialId) + schoolWishlistVotesKeys.voters(materialId) + baseSearchKeys.all
//                        (the total moves optimistically only when membership was known)
// useUnsubscribeSchool → same as useSubscribeSchool
// useChangeFavorite (school path) → schoolWishlistKeys.total() + schoolWishlistKeys.membership(materialId)
// useVoteSchoolWishlist / useUnvoteSchoolWishlist → schoolWishlistKeys.all
//
// Redux bridge: for a school master in the DE world this wishlist also lives in Redux state.main.favorite.
// The mutations' call sites dispatch getFavorite(), which re-reads only the first page; the mutations themselves
// invalidate the personal wishlistKeys.membership for ids beyond it. hooks/use-change-favorite.ts covers the reverse
// direction.
